import CustomIcon from "components/CustomIcon";
import Image from "next/image";
import { useDispatch } from "react-redux";
import { highlightSentences, clearHighlight } from "lib/redux/highlightSlice";

interface RepeatedSentencesProps {
  sentences: string[];
}

export const RepeatedSentences = ({ sentences }: RepeatedSentencesProps) => {
  const dispatch = useDispatch();
  const hasIssues = sentences.length > 0;

  // if (!hasIssues) {
  //   return (
  //     <div className="flex items-center gap-2 rounded-xl border-2 border-green-500 bg-white px-[15px] py-[15px] lg:gap-3 lg:px-[25px] lg:py-[25px]">
  //       <Image
  //         src="/icons/greenTick.svg"
  //         alt="No Repeated Sentences"
  //         width={30}
  //         height={30}
  //         className="h-5 w-5 lg:h-6 lg:w-6"
  //       />
  //       <span className="text-xs font-medium text-green-600 sm:text-sm md:text-base lg:text-xl lg:font-semibold">
  //         No Repeated Sentences detected
  //       </span>
  //     </div>
  //   );
  // }

  return (
    <div className="relative mt-8 flex flex-col gap-[10px] rounded-xl bg-[#FEE7E4] px-[15px] py-[10px] lg:gap-[16px] lg:px-[20px] lg:py-[14px]">
      <div className="absolute left-4 top-[-16px] flex items-center gap-2 rounded-xl bg-white px-4 py-2 font-bold text-black shadow-md lg:left-8 lg:px-6">
        <Image
          src="/icons/score-check/Announcement.svg"
          height={24}
          width={24}
          alt="icon"
          className="h-4 w-4 lg:h-5 lg:w-5"
        />
        <span className="text-sm font-bold lg:text-base xl:text-lg">
          Repeated Sentences Found
        </span>
      </div>

      <div className="mt-6">
        <ul className="flex list-disc flex-col items-start px-[3px] marker:text-base marker:text-[#92C5FF] sm:px-[5px] sm:marker:text-lg lg:marker:text-2xl">
          {sentences.map((sentence, index) => {
            const words = sentence.trim().split(/\s+/);
            const truncated = words.length > 12 ? words.slice(0, 12).join(" ") + "..." : sentence;
            return(
            <li
              key={index}
              className="my-[6px] pl-2 xl:pl-3 flex w-full items-center gap-2 rounded-lg bg-[#FFDCDC] px-3 py-2 text-xs font-normal text-[#000000] transition-opacity hover:opacity-80 md:text-base lg:my-[6px] lg:gap-4 lg:text-base xl:my-[10px] cursor-pointer"
              onMouseEnter={() => {
                dispatch(highlightSentences({
                  section: 'overall',
                  itemIndex: null,
                  sentences: [sentence]
                }));
              }}
              onMouseLeave={() => {
                dispatch(clearHighlight());
              }}
            >
              {/* <div className="h-auto w-auto">
                <CustomIcon
                  iconName="cross"
                  className="h-3 w-3 lg:h-4 lg:w-4"
                />
              </div> */}
              {truncated}
            </li>
          )})}
        </ul>

        <div className="mt-4 flex flex-col items-center justify-center gap-3">
          <div className="relative h-32 w-32 lg:h-40 lg:w-40">
            <Image
              src="/assets/resumeScore/RepeatedSentence.png"
              alt="Repeated sentences illustration"
              fill
              className="object-contain"
            />
          </div>
          <p className="text-center text-sm font-semibold text-red-600 lg:text-base">
            Repeated sentences reduce impact
          </p>
          <p className="text-center text-xs text-gray-600 lg:text-sm">
            Avoid using the same sentence multiple times across your resume.
          </p>
        </div>
      </div>
    </div>
  );
};
